<template>
  <b-card
    title="error detail"
  >
    <b-card-body>
      <b-row>
        <b-col>
          <b-row align-h="between">
            <b-col
                md="auto"
            >
              <span
                  class="d-block text-info"
                  style="margin-bottom:5px"
              >error ID</span>
              <b-badge
                  variant="light-info"
                  lang="en"
                  class="p-2"
              >
                <span class="text-dark">
                  {{details.Id}}
                </span>
              </b-badge>
            </b-col>
            <b-col
              md="auto"
            >
              <span
                class="d-block text-info"
                style="margin-bottom:5px"
              >error count</span>
              <b-badge
                variant="light-info"
                lang="en"
                class="p-2"
              >
                <span class="text-dark">
                  {{details.ErrorCount}}
                </span>
              </b-badge>
            </b-col>
            <b-col
              md="auto"
            >
              <span
                class="d-block text-info"
                style="margin-bottom:5px"
              >first occur</span>
              <b-badge
                variant="light-info"
                lang="en"
                class="p-2"
              >
                <span class="text-dark">
                  {{ details.FirstDate | date }}
                  <feather-icon
                    class="d-inline-block"
                    size="24"
                    icon="CalendarIcon"
                  />
                  {{details.FirstDate | date('YYYY-MM-DD')}}
                </span>
              </b-badge>
            </b-col>
            <b-col
              md="auto"
            >
              <span
                class="d-block text-info"
                style="margin-bottom:5px"
              >last occur</span>
              <b-badge
                variant="light-info"
                lang="en"
                class="p-2"
              >
                <span class="text-dark">
                  {{  details.LastDate | date }}
                  <feather-icon icon="CalendarIcon" />
                 {{ details.LastDate | date('YYYY-MM-DD') }}
                </span>
              </b-badge>
            </b-col>
            <b-col
              md="auto"
            >
              <span
                class="d-block text-info"
                style="margin-bottom:5px"
              >status</span>
              <b-badge
                variant="light-info"
                lang="en"
                class="p-2"
              >
                <span class="text-dark">
                  open
                </span>
              </b-badge>
            </b-col>
          </b-row>
          <b-card
            title="Title"
            border-variant="info"
            class="mt-1"
            header-text-variant="info"
            text-variant="info"
          >
            <b-card-body
              body-bg-variant="light-info"
            >
              <b-card-text class="text-dark">{{details.Title}}</b-card-text>
            </b-card-body>
          </b-card>
          <b-card
            title="Body"
            border-variant="info"
            class="mt-1"
          >
            <b-card-body
              body-bg-variant="light-info"
            >
              <b-card-text  class="text-dark">{{details.Body}}</b-card-text>
            </b-card-body>
          </b-card>
          <b-card
            title="users"
            border-variant="info"
            class="mt-1"
          >
            <b-card-body>
              <template v-for="detail in details.ErrorDetails">
              <b-card-sub-title class="text-info">
                {{ detail.Date | date }}
                <feather-icon icon="CalendarIcon" />
                {{detail.Date | date('YYYY-MM-DD')}}
                <feather-icon icon="ClockIcon" />
                {{detail.Date | date('HH:mm:ss')}}
              </b-card-sub-title>
              <b-card-body
                body-bg-variant="light-info"
                class="mb-1"
              >
                <div>
                <span>user id :</span>
                <b-card-text class="d-inline-block text-dark">
                  {{detail.UserId}}
                </b-card-text>
              </div>
                <div>
                <span>input param :</span>
                <b-card-text class="d-inline-block text-dark">
                  {{ getJSON(detail.InputParam) }}
                </b-card-text>
              </div>
              </b-card-body>
              </template>
            </b-card-body>
          </b-card>
          <b-button
              class="mb-1 mr-auto"
              variant="primary"
              @click="resolve"
          >
            resolve
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import Vue from "vue";
export default {
  name: 'ErrorDetails',
  data(){
    return {
      details:{
        Id:null,
        Title: null,
        Body: null,
        ErrorCount: null,
        FirstDate: null,
        LastDate: null,
        Closed: true,
        ErrorDetails:[{
          Date: null,
          UserId: null,
          InputParam: null
        }]
      }
    }
  },
  created() {
    this.$store.commit('appConfig/TOGGLE_RTL')
     this.makeToast =  (title, variant, toaster, text) => {
      this.$bvToast.toast(text, {
        title,
        toaster,
        variant,
        solid: false,
        appendToast: true,
      })
    }
    this.getDetail()
  },

  destroyed() {
    this.$store.commit('appConfig/TOGGLE_RTL')
  },
  methods: {
    getDetail(){
      this.loading=true
      this.$http.post(this.$api.errorlog.get,{
        Id : this.$route.params.id,
      }).then((response)=>{
        this.details = response.data
        this.loading=false
      })
    },
    onCopy() {
      this.makeToast('success', 'success', 'b-toaster-bottom-left', 'token is copied')
    },
    resolve() {
      this.loading = true
      this.$http.post(this.$api.errorlog.update,{
        Id : this.$route.params.id
      }).then(()=>{this.loading=false;this.back()}).finally(() => {this.loading = false})
    },
    getJSON(param){
      try {
        return JSON.parse(param)
      }catch(err) {
        return param;
      }
    }
  }
}
</script>

<style scoped>

</style>
